import axios from 'axios';

export const apiClient = axios.create();

export const getAuthToken = () => localStorage.getItem('token');

export const buildAuthHeaders = (headers = {}) => ({
    ...headers,
    Authorization: `Bearer ${getAuthToken()}`
});

export const buildAuthRequestConfig = (requestConfig = {}, defaultHeaders = {}) => ({
    headers: buildAuthHeaders(defaultHeaders),
    ...requestConfig
});
